/**
 * Smooth mouse-wheel scrolling (Theme settings › Animations › Smooth scrolling) with Lenis (assets/lenis.min.js,
 * loaded from here only when it is used). Computers with a mouse or trackpad only: touch scrolling stays native, and
 * layout/theme.liquid leaves this out in the theme editor. Visitors who ask for reduced motion keep native scrolling.
 *
 * The page still scrolls natively underneath, so the sticky header, scroll-driven animations and anchors keep
 * working; Lenis only eases wheel input. It pauses while the theme locks the page (drawers, menus), and wheel input
 * inside dialogs, drawers and other scrollable panels is left to the browser.
 */
(() => {
  if (window.obSmoothScroll) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const script = document.currentScript;
  const LERP = { subtle: 0.16, balanced: 0.11, silky: 0.075 };
  const LOCK_CLASSES = ['overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-desktop', 'ob-scroll-lock'];

  const start = () => {
    if (!window.Lenis) return;
    const lenis = new window.Lenis({
      autoRaf: true,
      lerp: LERP[script?.dataset.strength] || LERP.balanced,
      allowNestedScroll: true,
      stopInertiaOnNavigate: true,
      prevent: (node) => !!node.closest?.('dialog, [role="dialog"], cart-drawer, [data-lenis-prevent]'),
    });
    window.obSmoothScroll = lenis;

    // Pause while a drawer or menu locks the page.
    const sync = () => {
      const locked = LOCK_CLASSES.some((name) => document.body.classList.contains(name));
      if (locked) lenis.stop();
      else lenis.start();
    };
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    sync();
  };

  const lenisScript = document.createElement('script');
  lenisScript.src = script?.dataset.lenis;
  lenisScript.onload = start;
  document.head.append(lenisScript);
})();
